import { render } from "./forgotPassVerify.vue?vue&type=template&id=47512763&class=font-nunito"
import script from "./forgotPassVerify.vue?vue&type=script&lang=js"
export * from "./forgotPassVerify.vue?vue&type=script&lang=js"

import "./forgotPassVerify.vue?vue&type=style&index=0&id=47512763&lang=css"
script.render = render

export default script